module.exports = __webpack_public_path__ + "img/logo-footer.07b3959d.svg";